import { GraphqlPagination, InfiniteScrollTableComponents } from '@components/infiniteScroll';
import { Graph } from '@generated/graphql';
import { Box, TableRow, useTheme } from '@mui/material';
import { useCallback } from 'react';
import { TableVirtuoso } from 'react-virtuoso';
import { GraphsListViewHeader } from './GraphsListViewHeader';
import { GraphsListViewRow } from './GraphsListViewRow';

interface GraphsListViewProps {
  pagination: GraphqlPagination<Graph>;
  onItemClick: (graphId: string) => void;
  refetch: VoidFunction;
}

export const GraphsListView = ({
  pagination: { data, fetchMore },
  onItemClick,
  refetch,
}: GraphsListViewProps) => {
  const { palette } = useTheme();

  const tableRowComponent = useCallback(
    (props: { item: Graph }) => (
      <TableRow
        {...props}
        onClick={() => {
          onItemClick(props?.item?.graphId);
        }}
        sx={{
          '& *': { cursor: 'pointer !important' },
          '& .row-id-cell': { pl: '34px' },
          '& .row-id-cell-icon': { display: 'none !important' },
          '&:hover': {
            '& .row-id-cell': { pl: '2px' },
            '& .row-id-cell-icon': { display: 'flex !important' },
          },
        }}
      />
    ),
    [onItemClick],
  );

  const tableRow = (_index, graph: Graph) => <GraphsListViewRow graph={graph} refetch={refetch} />;
  return (
    <Box
      p={4}
      flex={1}
      data-test-id="virtuoso-item-list"
      sx={{ backgroundColor: palette.background.paper }}
    >
      <TableVirtuoso
        data={data}
        endReached={fetchMore}
        components={{ ...InfiniteScrollTableComponents, TableRow: tableRowComponent }}
        fixedHeaderContent={GraphsListViewHeader}
        itemContent={tableRow}
        increaseViewportBy={100}
      />
    </Box>
  );
};
